import { isMapboxURL, transformMapboxUrl } from "maplibregl-mapbox-request-transformer"

const mapboxKey = import.meta.env.VITE_MAPBOX_TOKEN!

// Ordnance Survey Data Hub keys, one per customer that brought their own. OS keys
// are browser-visible client keys (like the Mapbox token), issued under the
// council's PSGA entitlement, so each council's traffic must carry its own key.
// Customers on an OS style without an entry here (MED) fall back to the Essex key.
const OS_API_KEYS: Record<string, string | undefined> = {
  ESS: import.meta.env.VITE_ESS_OS_API_KEY,
  WSUS: import.meta.env.VITE_WSUS_OS_API_KEY,
}
const DEFAULT_OS_API_KEY = import.meta.env.VITE_ESS_OS_API_KEY

// The transformer is a module-level function shared by every map, so it learns
// the active customer through this setter (called by the customer provider)
// rather than through props. Keys are read per request, so a map that is already
// mounted picks up a customer switch on its next tile.
let activeCustomerId: string | undefined

export const setBasemapCustomer = (customerId: string | undefined) => {
  activeCustomerId = customerId || undefined
}

export const getOsApiKey = (customerId = activeCustomerId): string | undefined =>
  (customerId && OS_API_KEYS[customerId]) || DEFAULT_OS_API_KEY

export const transformRequest = (
  url: string,
  resourceType?: string,
) => {
  try {
    if (isMapboxURL(url)) {
      return transformMapboxUrl(url, resourceType as string, mapboxKey)
    }
    if (resourceType !== 'Style' && url.startsWith('https://api.os.uk')) {
      const urlObj = new URL(url);
      const osKey = getOsApiKey()
      if(!urlObj.searchParams.has('key') && osKey) urlObj.searchParams.append('key', osKey)
      if(!urlObj.searchParams.has('srs')) urlObj.searchParams.append('srs', '3857')
      return {
        url: new Request(urlObj).url
      }
    }
  } catch (e) {
    console.error("error in transformer", e)
    return { url }
  }

  // Do any other transforms you want
  return { url }
}
